import React from "react";
import { withRouter } from "react-router-dom";

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    const { pathname, search, hash } = this.props.location;
    const navChanged =
      pathname !== prevProps.location.pathname ||
      search !== prevProps.location.search;

    if (navChanged) {
      if (hash) {
        const el = document.getElementById(hash.substring(1));
        if (el) {
          el.scrollIntoView(); // or { behavior: "smooth" }
          return;
        }
      }
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
